import { UserRole } from "../../entities/user/user"

interface Props {
   role: UserRole
   size?: "sm" | "md" | "lg" | "xl"
}

export function UserRoleBadge({ role, size = "md" }: Props) {
   return (
      <span className={`badge badge-${size} ${role === "admin" ? "badge-accent" : "badge-info"}`}>
         {role === "admin" ? "Admin" : "Jeune"}
      </span>
   )
}
